'use strict';
/**
 * @author Maxim Seredkin
 */


export default function () {
    return {
        restrict: 'A',
        template: require('../view/custom-multiselect.html'),
        transclude: true,
        scope: {
            options: '=options',
            selectedModel: '=selectedModel',
            translationTexts: '=translationTexts',
            extraSettings: "=extraSettings"
        },
        controller: ['$scope', '$rootScope',
            function ($scope, $rootScope) {
                $scope.calculatePosition = (event) => {
                    const target = event.currentTarget;
                    if (!target) return;
                    const popup = target.children[0].children[1];
                    const clientRect = target.getBoundingClientRect();
                    if (!popup) return;
                    const windowHeight = window.innerHeight;
                    if ((clientRect.bottom + 50 + 200) >= windowHeight) {
                        popup.classList.add('dropdown-menu--bottom');
                    } else {
                        popup.classList.remove('dropdown-menu--bottom');
                    };
                };       
            }]
    };
}
